import {
  fetchJournalFilename as fetchJournalFilenameApi,
  fetchGenerateHistoricalTrialBalance as fetchGenerateHistoricalTrialBalanceApi,
} from '../../../shared/api';

export type journalPayload = {
  connName: string,
  periodName: string,
  calcId: number | null,
};

export const generateJournalPayload = async ({
  connName,
  periodName,
  calcId,
}: journalPayload) => {
  const displayName = await fetchJournalFilenameApi(connName, periodName, calcId);
  return displayName.journalFileName || '';
};

export const fetchHistoricalTrialBalanceData = async (calcId: number) => {
  const trialBalanceData = await fetchGenerateHistoricalTrialBalanceApi(calcId);
  return trialBalanceData || [];
};
